import React, { useState } from "react";

const HoverIcon = ({ src, hoverSrc, size, alt = "", ...rest }) => {
  const [hover, setHover] = useState(false);
  return (
    <span
      onPointerEnter={() => setHover(true)}
      onPointerLeave={() => setHover(false)}
      style={{ display: "inline-block", width: "100%", height: "100%" }}
    >
      <img
        src={hover && hoverSrc ? hoverSrc : src}
        alt={alt}
        width={size}
        height={size}
        style={{ display: "block", pointerEvents: "auto" }}
        {...rest}
      />
    </span>
  );
};

export default HoverIcon;
